
import { defineComponent, PropType } from "vue";
import { MdModal, MdModalComponentMixin } from "@/components/md/MdDialog";
import { MdButton } from "@/components/md/MdButton";
import { useStore } from "@/store";
import { InboxStore, RootStore } from "@/store/constants";
import { MdInputField } from "@/components/md/MdInput";
import { MdTooltip } from "@/components/md/MdTooltip";
import { ITag, ITagColor } from "@/types/inbox/tags";
import { Validator } from "@/classes/validators/Validator";
import { TextValidator } from "@/classes/validators/TextValidator";
import { createTag } from "@/api/inbox/settings/tags/create";
import { updateTag } from "@/api/inbox/settings/tags/update";
import { deleteTag } from "@/api/inbox/settings/tags/delete";

export default defineComponent({
  name: "TagDeleteModal",
  mixins: [MdModalComponentMixin],
  components: {
    MdModal,
    MdButton,
  },
  props: {
    tag: Object as PropType<ITag>,
  },
  setup() {
    return {
      store: useStore(),
    };
  },
  methods: {
    async deleteTag() {
      this.setLoadingState(true);
      if (!this.tag || !this.tag.id) return;
      try {
        await deleteTag(this.tag.id);
        this.store.dispatch(InboxStore.Actions.LOAD_TAGS);
        this.store.commit(RootStore.Mutations.SET_SNACKBAR, {
          state: "success",
          content: "Tag gelöscht",
        });
      } catch (err) {
        this.store.commit(RootStore.Mutations.SET_SNACKBAR, {
          state: "error",
          content: "Tag konnte nicht gelöscht werden",
        });
      }
      this.setLoadingState(false);
      this.close();
    },
  },
});
